import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EditOccupationAPI, getSingleOccupationAPI } from "../../../api";
import Loader from "../../Widgets/Loader/Loader";

const EditOccupationModal = ({
  showModal,
  handleClose,
  SelectedItem,
  getOccupationsFunction,
}) => {
  const [loading, setLoading] = useState(false);
  const [applicantOccupation, setApplicantOccupation] = useState("");
  const [applicantOccupationCode, setApplicantOccupationCode] = useState("");
  const [status, setStatus] = useState("active");

  const handleOccupationChange = (event) => {
    setApplicantOccupation(event.target.value);
  };

  const handleOccupationCodeChange = (event) => {
    setApplicantOccupationCode(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleAdd = async () => {

    if (!applicantOccupation) {
      toast.error("Occupation is required.");
      return;  
    }

    if (!applicantOccupationCode) {
      toast.error("Occupation Code is required.");
      return;
    }

    try {
      setLoading(true);

      // Create a new FormData object
      const formData = new FormData();
      formData.append("name", applicantOccupation);
      formData.append("number", applicantOccupationCode);
      formData.append("status", status);
      formData.append("id", SelectedItem?.id);

      const response = await EditOccupationAPI(formData);

      setLoading(false);

      if (
        response &&
        response.data &&
        response.data.response &&
        response.data.response.response === true
      ) {
        handleClose();
        toast.success(
          response.data.response.success_msg ||
            "Occupation updated successfully."
        );
        getOccupationsFunction();
      } else {
        toast.error(response.data.error_msg || "Error updating occupation.");
      }
    } catch (error) {
      setLoading(false);
      toast.error("An unexpected error occurred.");
    }
  };

  const getPrefilledDataFunction = async () => {
    if (!SelectedItem?.id) return;

    try {
      setLoading(true);

      const response = await getSingleOccupationAPI(SelectedItem.id);

      setLoading(false);

      if (
        response &&
        response.data &&
        response.data.response &&
        response.data.response.response === true &&
        response.data.response.data
      ) {
        const RES_Data = response.data.response.data;
        setApplicantOccupation(RES_Data.occupation_name || "");
        setApplicantOccupationCode(RES_Data.occupation_number || "");
        setStatus(RES_Data.occupation_status || "active");
      } else {
        console.error(
          "Error fetching occupation data:",
          response.data.error_msg || "Unknown error"
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching occupation data:", error);
    }
  };

  useEffect(() => {
    if (showModal) {
      getPrefilledDataFunction();
    }
  }, [showModal]);

  return (
    <>
      {loading && <Loader />}

      <Modal show={showModal} onHide={handleClose} animation={false} centered>
        <form onSubmit={handleAdd}>
          <Modal.Header>
            <Modal.Title className="modal-title text-center text-green">
              <h5>Edit Occupation</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md="6">
                <div className="zoom_details">
                  <label
                    htmlFor="applicantOccupation"
                    className="form-label label-font-size"
                  >
                    <p className="para">
                      Occupation <span className="text-danger">*</span>
                    </p>
                  </label>
                  <div className="zoom_details">
                    <input
                      name="applicantOccupation"
                      type="text"
                      className="form-control"
                      id="applicantOccupation"
                      value={applicantOccupation}
                      onChange={handleOccupationChange}
                      required
                    />
                  </div>
                </div>
              </Col>

              <Col md="6">
                <div className="zoom_details">
                  <label
                    htmlFor="applicantOccupationCode"
                    className="form-label label-font-size"
                  >
                    <p className="para">
                      Occupation Code <span className="text-danger">*</span>
                    </p>
                  </label>
                  <div className="zoom_details">
                    <input
                      name="applicantOccupationCode"
                      type="text"
                      className="form-control"
                      id="applicantOccupationCode"
                      value={applicantOccupationCode}
                      onChange={handleOccupationCodeChange}
                      required
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>
                  Status <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select mb-3"
                  aria-label="Default select example"
                  name="status"
                  onChange={handleStatusChange}
                  value={status}
                  style={{ cursor: "pointer" }}
                >
                  <option value="active">Active</option>
                  <option value="inactive">In-Active</option>
                </select>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="btn_yellow_green"
              style={{
                padding: "7px 20px",
                borderRadius: "6px",
                border: "none",
              }}
              onClick={handleClose}
            >
              Close
            </Button>
            <Button
              className="btn_modal"
              type="submit"
              onClick={handleAdd}
              style={{
                padding: "7px 20px",
                borderRadius: "6px",
                border: "none",
              }}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default EditOccupationModal;
